module.exports = __webpack_public_path__ + "static/media/RecomendaTiradentes.ee033623.jpg";